/**
 * Created by Michał Stawski on 2018-06-13.
 */
import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel
} from '@material-ui/core'
import { connect } from 'react-redux'
import { Field, initialize, reduxForm, SubmissionError } from 'redux-form'
import { Select, TextField } from 'redux-form-material-ui-adapter'
import { CLIENT_ACTION_SUCCESS } from 'redux-coreapi'
import { required } from 'redux-form-validators'
import { cleanValues } from 'reducers/schema'
import { clientAction } from '../../reducers/restApi'
import { DatePickerReduxWrapper } from '../DatePickerReduxWrapper'

const appSettings = {
  dateFormat: 'D MMM, YYYY',
}

// TODO move to one file
const req = required()

const fields = (props) => [
  { name: 'name', component: TextField, label: 'Name', validate: [req] },
  {
    name: 'date', component: DatePickerReduxWrapper, label: 'Date', validate: [req],
    props: {
      disableFuture: true,
      views: ['year', 'month', 'day'],
      openTo: 'year',
      autoOk: true,
      format: appSettings.dateFormat,
      emptyLabel: 'Choose a Date'
    }
  },
  {
    name: 'description', component: TextField, label: 'Description', validate: [req],
    props: { multiline: true }
  },
]

class PotentialAddDialog extends React.Component {
  state = {
    open: false,
    id: null,
  }

  componentDidMount () {
    this.props.initializeForm({})
  }

  render () {
    let {
      // objects,
      schema,
      handleSubmit,
      invalid, submitting,
      // ...props
    } = this.props
    // let item = {}

    // console.log(this.props)
    // if (selectedId && this.props.open) {
    //   item = objects.data[selectedId].instance
    // }
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            Add Event
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
            </DialogContentText>
            <form>
              {fields(this.props).map(field =>
                <FormControl fullWidth key={field.name}>
                  {field.component === Select ?
                    <InputLabel>{field.label}</InputLabel> : ''
                  }
                  <Field margin="dense" fullWidth
                         key={field.name}
                         component={field.component}
                         name={field.name}
                         label={field.label}
                         validate={field.validate}
                         props={field.props}
                         {...field.fieldProps}

                  >
                    {schema && field.childrenGenerator ? field.childrenGenerator(this.props) : field.children}
                  </Field>
                </FormControl>)}
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="primary">
              Cancel
            </Button>
            <Button
              disabled={invalid || submitting}
              color="primary" variant="contained"
              onClick={handleSubmit}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

      </div>
    )
  }
}

const onSubmit = (values, dispatch, props) => {
  dispatch((dispatch, getState) => {
    let sub
    values = { ...values }
    let state = getState()

    try {
      let objectType = 'treeEvent'
      // TODO better handle date field
      values.date = values.date.format().split('T')[0]
      if (values && values.id) {
        cleanValues(values, state, objectType, 'update')
        console.log('why are You here')
        sub = dispatch(clientAction([objectType, 'update'], values))
      } else {
        cleanValues(values, state, objectType, 'create')
        sub = dispatch(clientAction([objectType, 'create'], values))
      }

      if (sub.type) {
        console.error(sub)
      } else {
        sub.then(
          success => {
            if (success.type === CLIENT_ACTION_SUCCESS) {
              props.handleClose()
            } else {
              // dispatch(openSnackbar({message: 'Save Problem', autoHideDuration: 5000}));
              throw new SubmissionError('Save Problem')
            }
          }
        )
      }
    } catch (e) {
      console.error(e)
      throw new SubmissionError(e.validationErrors)
    }
  })
}

export default connect(
  (state) => {
    return {
      objects: state.restApi.treeEvent,

      schema: state.schema.schema,
    }
  },
  (dispatch) => ({
    dispatch: dispatch,
    initializeForm:
      (initialValues) => dispatch(initialize('eventAddForm', initialValues)),
  })
)(reduxForm({
  /** @namespace state.form.eventAddForm **/
  form: 'eventAddForm',
  enableReinitialize: false,
  onSubmit
})(PotentialAddDialog))
